<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <!-- <transition>用于实现过渡效果 -->
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <!-- 判断显示图片还是title -->
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title">{{ title }}</h1>
      </router-link>
    </transition>

  </div>
</template>

<script>
import { backDetailsView } from '@/api/home'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '聚合供应链',
      logo: '',
      channel_id: 0
    }
  },
  mounted() {
    this.getBackDetailsView()
  },
  methods: {
    getBackDetailsView() {
      let params = {
        type: 2,
        site_type: 3
      }
      backDetailsView(params).then(res => {
        if (res.code == 1) {
          this.title = res.data.channel_site[0].base_setting_res.name
          this.logo = res.data.channel_site[0].base_setting_res.logo
          document.title = res.data.channel_site[0].base_setting_res.title
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      /* width: 32px; */
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
